// extracted by mini-css-extract-plugin
module.exports = {"head":"index_head_2XNrL"};